import { COUNTRY } from '../constants';

/**
 * Formats the country parameters for the URL.
 * @param {object} query - The query parameters object.
 * @param {object} locale - The locale object containing country information.
 * @returns {object} - An object containing updated params and needsToRedirect flag.
 */
export function formatCountryParams(query: { [key: string]: string }, params: string, locale: { country: string }) {
	let needsToRedirect = false;
	if (!query.country) {
		const uniqueCountries = [...new Set(locale.country.split(','))].join(',');
		params += `${params.length ? '&' : ''}${COUNTRY}=${uniqueCountries.toUpperCase()}`;
		needsToRedirect = true;
	}

	return { params, needsToRedirect };
}

/**
 * Updates the URL parameters by calling the voyage type and country formatting functions.
 * @param {string} url - The current URL.
 * @param {object} query - The query parameters object.
 * @param {object} locale - The locale object containing country information.
 * @param {string} defaultVoyageType - The default voyage type.
 * @returns {object} - An object containing updated params and needsToRedirect flag.
 */
export function updateUrlParams(
	url: string,
	query: { [key: string]: string },
	params: string,
	locale: { country: string },
): { params: string; needsToRedirect: boolean } {
	let needsToRedirect = false;

	// Format country params
	const countryResult = formatCountryParams(query, params, locale);
	if (countryResult.needsToRedirect) {
		params = countryResult.params;
		needsToRedirect = true;
	}

	return { params, needsToRedirect };
}
